import { render, staticRenderFns } from "./terraform-statefile.vue?vue&type=template&id=2c0558a7&scoped=true&"
import script from "./terraform-statefile.vue?vue&type=script&lang=js&"
export * from "./terraform-statefile.vue?vue&type=script&lang=js&"
import style0 from "./terraform-statefile.vue?vue&type=style&index=0&id=2c0558a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0558a7",
  null
  
)

export default component.exports